import { z } from 'zod';

export const serverUserSchema = z.object({
  userId: z.string(),
  name: z.string().optional(),
});

export type ServerUser = z.infer<typeof serverUserSchema>;

export interface User {
  userId: string;
  name?: string;
}
